const constants = global.phpData.constants;

export const WP_SITE_URL = constants.SITE_URL;
export const WP_VERSION = constants.WP_VERSION;
export const WP_PERMALINK = constants.PERMALINK_STRUCTURE;
export const WP_SITE_TITLE = constants.SITE_TITLE;
export const WP_SITE_DESCRIPTION = constants.SITE_DESCRIPTION;
export const WP_API = constants.API;
export const POSTS_PER_PAGE = constants.POSTS_PER_PAGE;
export const MENUS_API = constants.MENUS_API;
export const FRONT_PAGE = constants.FRONT_PAGE;
export const MENU_API = constants.MENU_API;

export const REQUEST_API = 'REQUEST_API';
export const REQUEST_POSTS = 'REQUEST_POSTS';
export const REQUEST_POST = 'REQUEST_POST';
export const RECEIVE_POSTS = 'RECEIVE_POSTS';
export const RECEIVE_POST = 'RECEIVE_POST';
export const REQUEST_PAGES = 'REQUEST_PAGES';
export const REQUEST_PAGE = 'REQUEST_PAGE';
export const RECEIVE_PAGES = 'RECEIVE_PAGES';
export const RECEIVE_PAGE = 'RECEIVE_PAGE';
export const REQUEST_MENU = 'REQUEST_MENU';
export const RECEIVE_MENU = 'RECEIVE_MENU';
export const REQUEST_USER = 'REQUEST_USER';
export const RECEIVE_USER = 'RECEIVE_USER';
export const RECEIVE_SIDEBAR = 'RECEIVE_SIDEBAR';
export const REQUEST_SIDEBAR = 'REQUEST_SIDEBAR';
export const TOTAL_PAGES_FOR_POSTS = 'TOTAL_PAGES_FOR_POSTS';
export const TOTAL_PAGES_FOR_PAGES = 'TOTAL_PAGES_FOR_PAGES';
export const RECEIVE_TAGS = 'RECEIVE_TAGS';
export const REQUEST_TAGS = 'REQUEST_TAGS';
export const RECEIVE_POSTS_FOR_TAG = 'RECEIVE_POSTS_FOR_TAG';
export const REQUEST_POST_FOR_TAG = 'REQUEST_POST_FOR_TAG';
export const TOTAL_PAGES_FOR_TAGS = 'TOTAL_PAGES_FOR_TAGS';
export const TOTAL_PAGES_FOR_POSTS_FOR_TAG = 'TOTAL_PAGES_FOR_POSTS_FOR_TAG';
export const RECEIVE_CATEGORIES = 'RECEIVE_CATEGORIES';
export const REQUEST_CATEGORIES = 'REQUEST_CATEGORIES';
export const RECEIVE_POSTS_FOR_CATEGORY = 'RECEIVE_POSTS_FOR_CATEGORY';
export const REQUEST_POST_FOR_CATEGORY = 'REQUEST_POST_FOR_CATEGORY';
export const TOTAL_PAGES_FOR_CATEGORIES = 'TOTAL_PAGES_FOR_CATEGORIES';
export const TOTAL_PAGES_FOR_POSTS_FOR_CATEGORY = 'TOTAL_PAGES_FOR_POSTS_FOR_CATEGORY';
